import {StyledOfferingTitle} from "./offering-tile.style";

export function OfferingTitle({title}: {title: string}) {
  return <StyledOfferingTitle>{title}</StyledOfferingTitle>;
}
